import { TableConfig } from '../entities/table-config';
import { OnInit, Injector } from '@angular/core';
import { TableBase } from './tableBase';
import { MapperTableConfig } from '../entities/mapperTable-config';
export class TableMapperBase extends TableBase implements OnInit{
    tableObjSync: MapperTableConfig = new MapperTableConfig();
    constructor(
        injector: Injector
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.initTableConfig();
    }
    initTableConfig() {
        const tableConfig = this.getConfig();
        this.tableObjSync = {
            ...this.tableObjSync,
            ...tableConfig,
        };

    }
    getConfig() {
        return {};
    }
}
